import React, { useEffect, useRef, useState } from 'react'
import { Button } from 'primereact/button'
import { Tooltip } from 'primereact/tooltip'
import { Checkbox } from 'primereact/checkbox'
import { enums } from '../../../constants'
import utils, { getMessage } from '../../../utils'

import './ConfiguracaoBoletoForm.scss'
import LtsInputText from '../../../components/lottus/lts-input-text'
import LtsInputNumber from '../../../components/lottus/lts-input-number'
import LtsDropdownIdValue from '../../../components/lottus/lts-dropdown-id-value'
import _ from 'lodash'
import LtsCurrency from '../../../components/lottus/lts-currency'
import LtsLookupUnidade from '../../../components/lottus/lts-lookup-unidade'
import LtsCalendar from '../../../components/lottus/lts-calendar'
import LtsTextArea from '../../../components/lottus/lts-text-area'
import LtsDropdownEnum from '../../../components/lottus/lts-dropdown-enum'
import LtsPassword from '../../../components/lottus/lts-password'
import LtsLookupCertificadoDigital from '../../../components/lottus/lts-lookup-certificado-digital'
import LtsJsonArea from '../../../components/lottus/lts-json-area'
import { renderConfigArquivoRetornoForm, validateConfigArquivoRetorno } from './config-arquivo-retorno-form'
import ConfigDescontoAilos from './ConfigDescontoAilos'
import ConfigDescontoCaixa from './ConfigDescontoCaixa'
import ConfigDescontoSicoob from './ConfigDescontoSicoob'
import ConfigDescontoSantander from './ConfigDescontoSantander'
import { buildInstrucoes, mergeInstrucoes } from '../utils'
import {
  isTipoBoletoAilos,
  isTipoBoletoBB,
  isTipoBoletoBradesco,
  isTipoBoletoCaixa,
  isTipoBoletoCnab,
  isTipoBoletoCnab400,
  isTipoBoletoItau,
  isTipoBoletoSantander,
  isTipoBoletoSicoob,
  isTipoBoletoSicredi,
} from '../../../utils/tipo-boleto-utils'
import {
  isTipoBancoBanrisul,
  isTipoBancoBradesco,
  isTipoBancoCaixa,
  isTipoBancoItau,
  isTipoBancoSantander,
  isTipoBancoSicredi,
} from '../../../utils/tipo-banco-utils'
import ConfigDescontoBB from './ConfigDescontoBB'

export const ConfiguracaoBoletoForm = (props) => {
  const messages = props.messages
  const record = props.record

  const [autoInstrucoes, setAutoInstrucoes] = useState(true)
  const [codigoBancoReadOnly, setCodigoBancoReadOnly] = useState(false)
  const [validacaoToken, setValidacaoToken] = useState({ requestInfo: '', responseInfo: '' })

  const exibeValidarToken =
    isTipoBoletoAilos(record.tipoBoleto) ||
    isTipoBoletoBB(record.tipoBoleto) ||
    isTipoBoletoBradesco(record.tipoBoleto) ||
    isTipoBoletoItau(record.tipoBoleto) ||
    isTipoBoletoSicoob(record.tipoBoleto) ||
    isTipoBoletoSicredi(record.tipoBoleto) ||
    isTipoBoletoSantander(record.tipoBoleto)

  const configDescontoCacheRef = useRef({})
  const prevTipoBoletoIdRef = useRef(record?.tipoBoleto?.id)

  useEffect(() => {
    setAutoInstrucoes(true)
  }, [record?.oid])

  useEffect(() => {
    configDescontoCacheRef.current = {}
    const tipoId = record?.tipoBoleto?.id
    if (tipoId != null) {
      configDescontoCacheRef.current[tipoId] = record?.configDesconto ?? null
    }
    prevTipoBoletoIdRef.current = tipoId

    ajustarIdentificacaoBoletoAceito()

    ajustarValorCodigoCarteira()
  }, [record?.oid])

  useEffect(() => {
    const mapeamento = (enums.TipoBoletoBanco || []).find((item) => item?.id === record?.tipoBoleto?.id)
    setCodigoBancoReadOnly(!!mapeamento?.banco?.id)
  }, [record?.oid, record?.tipoBoleto?.id])

  useEffect(() => {
    const currentTipoId = record?.tipoBoleto?.id
    const prevTipoId = prevTipoBoletoIdRef.current

    const usaConfigDesconto =
      isTipoBoletoAilos(record?.tipoBoleto) ||
      isTipoBoletoCaixa(record?.tipoBoleto) ||
      isTipoBoletoSicoob(record?.tipoBoleto) ||
      isTipoBoletoSantander(record?.tipoBoleto)

    if (prevTipoId != null && prevTipoId !== currentTipoId) {
      configDescontoCacheRef.current[prevTipoId] = record?.configDesconto ?? null
    }

    if (currentTipoId == null || !usaConfigDesconto) {
      const currentValue = record?.configDesconto ?? null
      if (currentValue != null) {
        props.onChangeField('configDesconto', null)
      }
      prevTipoBoletoIdRef.current = currentTipoId
      return
    }

    const cached = configDescontoCacheRef.current[currentTipoId]
    const nextValue = cached ?? null
    const currentValue = record?.configDesconto ?? null
    if (currentValue !== nextValue) {
      props.onChangeField('configDesconto', nextValue)
    }

    prevTipoBoletoIdRef.current = currentTipoId
  }, [record?.tipoBoleto?.id])

  useEffect(() => {
    ajustarValorCodigoCarteira()
  }, [record.codigoBanco])

  let unidade = {}
  if (record.unidade.id) {
    unidade = { id: record.unidade.id, value: record.unidade.value }
  }

  function ajustarIdentificacaoBoletoAceito() {
    if (!record.identificacaoBoletoAceito) {
      props.onChangeField('identificacaoBoletoAceito', 'A')
    }
  }

  function ajustarValorCodigoCarteira() {
    const novasOpcoes = getCodigoCarteiraOptions()

    if (!novasOpcoes || novasOpcoes.length === 0) {
      return
    }

    const valorAtual = record.tipoCobranca
    const valorExisteNaLista = novasOpcoes.some(
      (opcao) => opcao.value === valorAtual?.value && opcao.id === valorAtual?.id
    )

    if (!valorExisteNaLista) {
      props.onChangeField('tipoCobranca', novasOpcoes[0])
    }
  }

  function mostrarFormaEmissao() {
    return (
      isTipoBoletoAilos(record.tipoBoleto) ||
      isTipoBoletoSicoob(record.tipoBoleto) ||
      (isTipoBoletoCnab(record.tipoBoleto) && isTipoBancoBanrisul(record.codigoBanco))
    )
  }

  function mostrarTipoDesconto() {
    return (
      isTipoBoletoAilos(record.tipoBoleto) ||
      isTipoBoletoBradesco(record.tipoBoleto) ||
      isTipoBoletoSicredi(record.tipoBoleto) ||
      isTipoBoletoCnab(record.tipoBoleto)
    )
  }

  function mostrarValorAbatimento() {
    return isTipoBoletoAilos(record.tipoBoleto) || isTipoBoletoSantander(record.tipoBoleto)
  }

  function mostrarModalidadeCarteira() {
    return (
      isTipoBoletoCnab(record.tipoBoleto) &&
      (isTipoBancoSantander(record.codigoBanco) || isTipoBancoBanrisul(record.codigoBanco))
    )
  }

  function getEspecieDocumentoOptions() {
    const all = enums.EspecieDocumento

    const allowedIdsCaixaItau = [1, 2, 3, 4, 6, 7]
    const allowedIdsSantanderSicredi = [1, 2, 3, 6, 7]

    let allowedIds = null

    if (isTipoBoletoCaixa(record.tipoBoleto)) {
      allowedIds = allowedIdsCaixaItau
    } else if (isTipoBoletoSantander(record.tipoBoleto) || isTipoBoletoSicredi(record.tipoBoleto)) {
      allowedIds = allowedIdsSantanderSicredi
    } else if (isTipoBoletoItau(record.tipoBoleto)) {
      allowedIds = allowedIdsCaixaItau
    } else if (isTipoBoletoCnab400(record.tipoBoleto) && isTipoBancoItau(record.codigoBanco)) {
      allowedIds = allowedIdsCaixaItau
    }

    if (!allowedIds) return all
    return all.filter((item) => allowedIds.includes(item.id))
  }

  function getCodigoCarteiraOptions() {
    if (isTipoBancoSantander(record.codigoBanco)) return enums.CodigoCarteiraSantander
    if (isTipoBancoBanrisul(record.codigoBanco)) return enums.CodigoCarteiraBanrisul
    if (isTipoBancoBradesco(record.codigoBanco)) return enums.CodigoCarteiraBradesco
    if (isTipoBancoCaixa(record.codigoBanco)) return enums.CodigoCarteiraCaixa
    if (isTipoBancoSicredi(record.codigoBanco)) return enums.CodigoCarteiraSicredi
    return enums.CodigoCarteiraFebraban
  }

  function mostrarConfigDesconto() {
    return (
      isTipoBoletoAilos(record.tipoBoleto) ||
      isTipoBoletoCaixa(record.tipoBoleto) ||
      isTipoBoletoSantander(record.tipoBoleto) ||
      isTipoBoletoSicoob(record.tipoBoleto) ||
      isTipoBoletoBB(record.tipoBoleto)
    )
  }

  function mostrarCamposClient() {
    return (
      isTipoBoletoBradesco(record.tipoBoleto) ||
      isTipoBoletoSicredi(record.tipoBoleto) ||
      isTipoBoletoBB(record.tipoBoleto)
    )
  }

  function renderConfigDesconto() {
    const tipoBoletoId = record.tipoBoleto?.id
    const configDescontoValue =
      (tipoBoletoId != null ? configDescontoCacheRef.current[tipoBoletoId] : undefined) ?? record.configDesconto ?? null

    const onChangeConfigDesconto = (value) => {
      if (tipoBoletoId != null) {
        configDescontoCacheRef.current[tipoBoletoId] = value
      }
      props.onChangeField('configDesconto', value)
    }

    const tipoDescontoId = record.tipoDesconto?.id
    const permiteConfigDescontoAilos = [
      enums.NomesTipoInstrucaoValor.VALOR_EM_REAIS,
      enums.NomesTipoInstrucaoValor.PERCENTUAL,
    ].includes(tipoDescontoId)

    if (isTipoBoletoAilos(record.tipoBoleto) && permiteConfigDescontoAilos) {
      return <ConfigDescontoAilos value={configDescontoValue} onChange={onChangeConfigDesconto} />
    }

    if (isTipoBoletoCaixa(record.tipoBoleto)) {
      return <ConfigDescontoCaixa value={configDescontoValue} onChange={onChangeConfigDesconto} />
    }

    if (isTipoBoletoSicoob(record.tipoBoleto)) {
      return <ConfigDescontoSicoob value={configDescontoValue} onChange={onChangeConfigDesconto} />
    }

    if (isTipoBoletoSantander(record.tipoBoleto)) {
      return <ConfigDescontoSantander value={configDescontoValue} onChange={onChangeConfigDesconto} />
    }

    if (isTipoBoletoBB(record.tipoBoleto)) {
      return <ConfigDescontoBB value={configDescontoValue} onChange={onChangeConfigDesconto} />
    }

    return null
  }

  function mostrarDadosNegativacaoBaixa() {
    return (
      isTipoBoletoAilos(record.tipoBoleto) ||
      isTipoBoletoCnab(record.tipoBoleto) ||
      isTipoBoletoSicoob(record.tipoBoleto) ||
      isTipoBoletoItau(record.tipoBoleto) ||
      isTipoBoletoBB(record.tipoBoleto)
    )
  }

  function mostrarDadosReciboRegistro() {
    return isTipoBoletoAilos(record.tipoBoleto) || isTipoBoletoCnab(record.tipoBoleto)
  }

  function mostrarDadosAutenticacaoApi() {
    return (
      isTipoBoletoBradesco(record.tipoBoleto) ||
      mostrarCamposClient(record.tipoBoleto) ||
      isTipoBoletoSantander(record.tipoBoleto)
    )
  }

  function mostrarDadosDesconto() {
    return (
      mostrarTipoDesconto() ||
      isTipoBoletoBradesco(record.tipoBoleto) ||
      mostrarValorAbatimento() ||
      mostrarConfigDesconto()
    )
  }

  function isTipoRetornoBoletoValido() {
    return record.tipoRetornoBoleto?.id !== enums.TipoRetornoBoleto[0].id
  }

  function getDadosBancarios() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.dadosbancarios')}</h3>
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-6 p-md-6 p-lg-6">
                <LtsDropdownIdValue
                  value={record.codigoBanco}
                  options={[...enums.TipoBancoLookup].sort((a, b) =>
                    String(a.value).localeCompare(String(b.value), 'pt-BR', { sensitivity: 'base' })
                  )}
                  onChange={(e) => props.onChangeField('codigoBanco', e)}
                  disabled={codigoBancoReadOnly}
                  optionLabel="value"
                  optionValue={(v) => v}
                  dataKey="id"
                  resolveValueFn={(value) => {
                    if (value && value.id) {
                      return enums.TipoBancoLookup.find((item) => item.id === value.id) || value
                    }
                    return value
                  }}
                  name="codigoBanco"
                  label={utils.getMessage(messages, 'configuracaoboleto.label.codigobanco')}
                />
              </div>
            </div>

            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-6 p-md-6 p-lg-6">
                <LtsInputNumber
                  name={'agencia'}
                  value={record.agencia}
                  onChange={(e) => props.onChangeField('agencia', e)}
                  label={getMessage(messages, 'configuracaoboleto.label.agencia')}
                  format={false}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-md-6 p-lg-6">
                <LtsInputNumber
                  name={'digitoAgencia'}
                  value={record.digitoAgencia}
                  onChange={(e) => props.onChangeField('digitoAgencia', e)}
                  label={getMessage(messages, 'configuracaoboleto.label.digitoagencia')}
                  format={false}
                />
              </div>

              <div className="p-col-12 p-sm-6 p-md-6 p-lg-6">
                <LtsInputNumber
                  name={'codigo'}
                  value={record.codigo}
                  onChange={(e) => props.onChangeField('codigo', e)}
                  label={getMessage(messages, 'configuracaoboleto.label.conta')}
                  format={false}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-md-6 p-lg-6">
                <LtsInputNumber
                  name={'digitoConta'}
                  value={record.digitoConta}
                  onChange={(e) => props.onChangeField('digitoConta', e)}
                  label={getMessage(messages, 'configuracaoboleto.label.digitoconta')}
                  format={false}
                />
              </div>

              {(isTipoBoletoAilos(record.tipoBoleto) || isTipoBoletoSicredi(record.tipoBoleto)) && (
                <div className="p-col-12 p-sm-6 p-md-6 p-lg-6">
                  <LtsInputNumber
                    name={'codigoCooperativa'}
                    value={record.codigoCooperativa}
                    onChange={(e) => props.onChangeField('codigoCooperativa', e)}
                    label={getMessage(messages, 'configuracaoboleto.label.codigocooperativa')}
                    format={false}
                  />
                </div>
              )}

              {isTipoBoletoSicredi(record.tipoBoleto) && (
                <div className="p-col-12 p-sm-6 p-md-6 p-lg-6">
                  <LtsInputNumber
                    name={'posto'}
                    value={record.posto}
                    onChange={(e) => props.onChangeField('posto', e)}
                    label={getMessage(messages, 'configuracaoboleto.label.posto')}
                    format={false}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function getDadosPix() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.pix')}</h3>
            <div className="p-grid form-group">
              <div className="p-col-12">
                <Checkbox
                  inputId="gerarComQrcode"
                  checked={record.gerarComQrcode}
                  onChange={(e) => props.onChangeField('gerarComQrcode', e.checked)}
                  name="gerarComQrcode"
                />
                <label htmlFor="gerarComQrcode" className="p-checkbox-label p-ml-2">
                  {utils.getMessage(messages, 'configuracaoboleto.label.gerarcomqrcode')}
                </label>
              </div>
              {getPixFields()}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function getPixFields() {
    if (record.gerarComQrcode) {
      return (
        <>
          <div className="p-col-12">
            <LtsDropdownEnum
              value={record.tipoChavePix}
              options={enums.TiposChavesPix}
              onChange={(value) => props.onChangeField('tipoChavePix', value)}
              optionLabel="value"
              optionValue="id"
              name="tipoChavePix"
              label={getMessage(messages, 'configuracaoboleto.label.tipochavepix')}
            />
          </div>
          <div className="p-col-12">
            <LtsInputText
              value={record.chavePix}
              onChange={(e) => props.onChangeField('chavePix', e)}
              name="chavePix"
              label={getMessage(messages, 'configuracaoboleto.label.chavepix')}
            />
          </div>
        </>
      )
    }
  }

  function getDadosProtesto() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.protesto')}</h3>
            <div className="p-grid form-group">
              {isTipoBoletoCnab(record.tipoBoleto) && (
                <div className="p-col-12">
                  <LtsDropdownIdValue
                    value={record.tipoProtesto}
                    options={enums.TipoProtesto}
                    onChange={(e) => props.onChangeField('tipoProtesto', e)}
                    optionLabel="value"
                    optionValue={(v) => v}
                    dataKey="value"
                    name="tipoProtesto"
                    label={utils.getMessage(messages, 'configuracaoboleto.label.protesto')}
                  />
                </div>
              )}

              <div className="p-col-12">
                <LtsInputNumber
                  name={'diasProtesto'}
                  value={record.diasProtesto}
                  onChange={(e) => props.onChangeField('diasProtesto', e)}
                  min={0}
                  max={99}
                  label={getMessage(messages, 'configuracaoboleto.label.diasprotesto')}
                  format={false}
                />
              </div>

              {isTipoBoletoBradesco(record.tipoBoleto) && (
                <div className="p-col-12">
                  <LtsDropdownIdValue
                    value={record.tipoDecursoProtesto}
                    options={enums.TipoPrazo}
                    onChange={(e) => props.onChangeField('tipoDecursoProtesto', e)}
                    optionLabel="value"
                    optionValue={(v) => v}
                    dataKey="value"
                    name="tipoDecursoProtesto"
                    label={utils.getMessage(messages, 'configuracaoboleto.label.tipodecursoprotesto')}
                  />
                </div>
              )}

              {isTipoBoletoCaixa(record.tipoBoleto) && (
                <div className="p-col-12">
                  <LtsDropdownEnum
                    value={record.acaoProtesto}
                    options={enums.TipoAcaoProtesto}
                    onChange={(value) => props.onChangeField('acaoProtesto', value)}
                    optionLabel="label"
                    optionValue="value"
                    name="acaoProtesto"
                    label={getMessage(messages, 'configuracaoboleto.label.acaoprotesto')}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function getDadosArquivoRetorno() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.arquivoretorno')}</h3>
            <div className="p-grid form-group">
              <div className="p-col-12 p-md-6">
                <LtsInputText
                  value={record.extensaoArquivoRetorno}
                  onChange={(e) => props.onChangeField('extensaoArquivoRetorno', e)}
                  name="extensaoArquivoRetorno"
                  label={getMessage(messages, 'configuracaoboleto.label.extensaoarquivoretorno')}
                />
              </div>

              <div className="p-col-12">
                <LtsJsonArea
                  value={record.configArquivoRetorno}
                  onChange={(value) => props.onChangeField('configArquivoRetorno', value)}
                  name="configArquivoRetorno"
                  rows={10}
                  label={getMessage(messages, 'configuracaoboleto.label.configarquivoretorno')}
                  modalTitle={getMessage(messages, 'configuracaoboleto.label.modal.edicaovisual.title')}
                  modalWidth="60vw"
                  renderForm={renderConfigArquivoRetornoForm}
                  validate={validateConfigArquivoRetorno}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  function getDadosAutenticacaoApi() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.autenticacaoapi')}</h3>
            <div className="p-grid form-group">
              {(isTipoBoletoBradesco(record.tipoBoleto) || isTipoBoletoBB(record.tipoBoleto)) && (
                <div className="p-col-12">
                  <LtsLookupCertificadoDigital
                    label={utils.getMessage(messages, 'configuracaoboleto.label.certificadodigital')}
                    value={_.get(record, 'certificadoDigital.value', '')}
                    oidRecord={_.get(record, 'certificadoDigital.id', '')}
                    history={props.history}
                    onChange={(e) => props.setCertificadoDigital(e)}
                  />
                </div>
              )}

              {isTipoBoletoAilos(record.tipoBoleto) && (
                <>
                  <div className="p-col-12">
                    <LtsInputText
                      value={record.appKey}
                      onChange={(e) => props.onChangeField('appKey', e)}
                      name="appKey"
                      label="App Key"
                    />
                  </div>

                  <div className="p-col-12">
                    <LtsInputText
                      value={record.codigoMoeda}
                      onChange={(e) => props.onChangeField('codigoMoeda', e)}
                      name="codigoMoeda"
                      label="Código Moeda"
                    />
                  </div>

                  <div className="p-col-12">
                    <LtsInputText
                      value={record.nossoNumero}
                      onChange={(e) => props.onChangeField('nossoNumero', e)}
                      name="nossoNumero"
                      label="Nosso Número"
                    />
                  </div>

                  <div className="p-col-12">
                    <LtsInputText
                      value={record.linhaDigitavelCampo01}
                      onChange={(e) => props.onChangeField('linhaDigitavelCampo01', e)}
                      name="linhaDigitavelCampo01"
                      label="Linha Digitável Campo 01"
                    />
                  </div>

                  <div className="p-col-12">
                    <LtsInputText
                      value={record.linhaDigitavelCampo02}
                      onChange={(e) => props.onChangeField('linhaDigitavelCampo02', e)}
                      name="linhaDigitavelCampo02"
                      label="Linha Digitável Campo 02"
                    />
                  </div>
                </>
              )}

              {mostrarCamposClient(record.tipoBoleto) && (
                <>
                  <div className="p-col-12">
                    <LtsInputText
                      value={record.clientId}
                      onChange={(e) => props.onChangeField('clientId', e)}
                      name="clientId"
                      label={getMessage(messages, 'configuracaoboleto.label.clientid')}
                      autoComplete="off"
                    />
                  </div>

                  <div className="p-col-12">
                    <LtsPassword
                      type="password"
                      onChange={(e) => props.onChangeField('clientSecret', e)}
                      value={record.clientSecret}
                      name="clientSecret"
                      label={getMessage(messages, 'configuracaoboleto.label.clientsecret')}
                      toggleMask
                      autoComplete="new-password"
                    />
                  </div>
                </>
              )}

              {isTipoBoletoSicredi(record.tipoBoleto) && (
                <>
                  {/*
                    phoenix-937: a API Pix e a API de Cobrança do Sicredi são produtos distintos,
                    com credenciais próprias. Os campos acima autenticam o boleto; estes, o Pix.
                  */}
                  <div className="p-col-12">
                    <LtsInputText
                      value={record.pixClientId}
                      onChange={(e) => props.onChangeField('pixClientId', e)}
                      name="pixClientId"
                      label="Client ID - PIX"
                      autoComplete="off"
                    />
                  </div>

                  <div className="p-col-12">
                    <LtsPassword
                      type="password"
                      onChange={(e) => props.onChangeField('pixClientSecret', e)}
                      value={record.pixClientSecret}
                      name="pixClientSecret"
                      label="Client Secret - PIX"
                      toggleMask
                      autoComplete="new-password"
                    />
                  </div>
                </>
              )}

              {isTipoBoletoBB(record.tipoBoleto) && (
                <div className="p-col-12">
                  <LtsInputText
                    value={record.appKey}
                    onChange={(e) => props.onChangeField('appKey', e)}
                    name="appKey"
                    label="App Key"
                  />
                </div>
              )}

              {isTipoBoletoSantander(record.tipoBoleto) && (
                <div className="p-col-12">
                  <LtsInputText
                    value={record.workspaceId}
                    onChange={(e) => props.onChangeField('workspaceId', e)}
                    name="workspaceId"
                    label={getMessage(messages, 'configuracaoboleto.label.workspaceid')}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function getDadosTipoBoletoRetorno() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.tipoboletoretorno')}</h3>
            <div className="p-grid form-group">
              <div className="p-col-12">
                <LtsDropdownIdValue
                  value={record.tipoBoleto}
                  options={[...enums.TipoBoletoLookup].sort((a, b) =>
                    String(a.value).localeCompare(String(b.value), 'pt-BR', { sensitivity: 'base' })
                  )}
                  onChange={(e) => {
                    props.onChangeField('tipoBoleto', e)

                    const mapeamento = (enums.TipoBoletoBanco || []).find((item) => item?.id === e?.id)
                    const banco = mapeamento?.banco
                    if (banco?.id) {
                      props.onChangeField('codigoBanco', banco)
                      setCodigoBancoReadOnly(true)
                    } else {
                      setCodigoBancoReadOnly(false)
                    }
                  }}
                  optionLabel="value"
                  optionValue={(v) => v}
                  dataKey="id"
                  resolveValueFn={(value) => {
                    if (value && value.id) {
                      return enums.TipoBoletoLookup.find((item) => item.id === value.id) || value
                    }
                    return value
                  }}
                  name="tipoBoleto"
                  label={utils.getMessage(messages, 'configuracaoboleto.label.tipoboleto')}
                />
              </div>

              <div className="p-col-12">
                <LtsDropdownIdValue
                  value={record.tipoRetornoBoleto}
                  options={enums.TipoRetornoBoleto}
                  onChange={(e) => props.onChangeField('tipoRetornoBoleto', e)}
                  optionLabel="value"
                  optionValue={(v) => v}
                  dataKey="value"
                  name="tipoRetornoBoleto"
                  label={utils.getMessage(messages, 'configuracaoboleto.label.tiporetornoboleto')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  function getDadosConvenioCarteira() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.convenioecarteira')}</h3>
            <div className="p-grid form-group">
              <div className="p-col-12">
                <LtsInputNumber
                  keyfilter="pint"
                  value={record.numeroConvenioCobranca}
                  onChange={(e) => props.onChangeField('numeroConvenioCobranca', e)}
                  name="numeroConvenioCobranca"
                  label={getMessage(messages, 'configuracaoboleto.label.numerocobrancaconvenio')}
                />
              </div>

              <div className="p-col-12">
                <LtsInputNumber
                  keyfilter="pint"
                  value={record.codigoCarteiraCobranca}
                  onChange={(e) => props.onChangeField('codigoCarteiraCobranca', e)}
                  name="codigoCarteiraCobranca"
                  label={getMessage(messages, 'configuracaoboleto.label.numerocobrancacarteira')}
                />
              </div>

              {isTipoBoletoSicoob(record.tipoBoleto) && (
                <div className="p-col-12">
                  <LtsInputText
                    value={record.numeroContrato}
                    onChange={(e) => props.onChangeField('numeroContrato', e)}
                    name="numeroContrato"
                    label={getMessage(messages, 'configuracaoboleto.label.numerocontrato')}
                  />
                </div>
              )}

              {mostrarModalidadeCarteira() && (
                <div className="p-col-12">
                  <LtsInputText
                    keyfilter="pint"
                    value={record.tipoModalidadeCarteira}
                    onChange={(e) => props.onChangeField('tipoModalidadeCarteira', e)}
                    name="tipoModalidadeCarteira"
                    label={getMessage(messages, 'configuracaoboleto.label.tipomodalidadecarteira')}
                  />
                </div>
              )}

              {isTipoBoletoBB(record.tipoBoleto) && (
                <div className="p-col-12">
                  <LtsDropdownIdValue
                    value={record.tipoConvenioBb}
                    options={enums.TipoConvenioBb}
                    onChange={(e) => props.onChangeField('tipoConvenioBb', e)}
                    optionLabel="value"
                    optionValue={(v) => v}
                    dataKey="id"
                    name="tipoConvenioBb"
                    label="Tipo de Convênio BB"
                  />
                </div>
              )}

              {isTipoBoletoBB(record.tipoBoleto) && (
                <div className="p-col-12">
                  <LtsInputNumber
                    name="numeroVariacaoCarteiraCobranca"
                    value={record.numeroVariacaoCarteiraCobranca}
                    onChange={(e) => props.onChangeField('numeroVariacaoCarteiraCobranca', e)}
                    label="Variação da Carteira"
                    format={false}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function getDadosDocumentoEmissao() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.documentoeemissao')}</h3>
            <div className="p-grid form-group">
              {isTipoBoletoAilos(record.tipoBoleto) && (
                <>
                  <div className="p-col-12">
                    <LtsInputText
                      keyfilter="pint"
                      value={record.numeroDocumento}
                      onChange={(e) => props.onChangeField('numeroDocumento', e)}
                      name="numeroDocumento"
                      readOnly
                      label={getMessage(messages, 'configuracaoboleto.label.numerodocumento')}
                    />
                  </div>
                  <div className="p-col-12">
                    <LtsInputText
                      value={record.descricaoDocumento}
                      onChange={(e) => props.onChangeField('descricaoDocumento', e)}
                      name="descricaoDocumento"
                      label={getMessage(messages, 'configuracaoboleto.label.descricaodocumento')}
                    />
                  </div>
                  <div className="p-col-12">
                    <LtsCalendar
                      value={record.dataEmissao}
                      onChange={(e) => props.onChangeField('dataEmissao', e)}
                      name="dataEmissao"
                      label={getMessage(messages, 'configuracaoboleto.label.dataemissao')}
                    />
                  </div>
                </>
              )}

              <div className="p-col-12">
                <LtsDropdownIdValue
                  disabled={props.especieDocumento}
                  value={record.especieDocumento}
                  options={getEspecieDocumentoOptions()}
                  onChange={(e) => props.onChangeField('especieDocumento', e)}
                  optionLabel="value"
                  optionValue={(v) => v}
                  dataKey="value"
                  name="especieDocumento"
                  label={utils.getMessage(messages, 'configuracaoboleto.label.especiedocumento')}
                />
              </div>

              {mostrarFormaEmissao() && (
                <>
                  <div className="p-col-12">
                    <LtsDropdownIdValue
                      value={record.formaEmissao}
                      options={enums.FormaEmissao}
                      onChange={(e) => props.onChangeField('formaEmissao', e)}
                      optionLabel="value"
                      optionValue={(v) => v}
                      dataKey="value"
                      name="formaEmissao"
                      label={utils.getMessage(messages, 'configuracaoboleto.label.formaemissao')}
                    />
                  </div>

                  <div className="p-col-12">
                    <LtsDropdownIdValue
                      value={record.formaEmissaoRemessa}
                      options={enums.FormaEmissao}
                      onChange={(e) => props.onChangeField('formaEmissaoRemessa', e)}
                      optionLabel="value"
                      optionValue={(v) => v}
                      dataKey="value"
                      name="formaEmissaoRemessa"
                      label={utils.getMessage(messages, 'configuracaoboleto.label.formaemissaoremessa')}
                    />
                  </div>
                </>
              )}

              {isTipoBoletoCnab(record.tipoBoleto) && (
                <div className="p-col-12">
                  <LtsInputText
                    keyfilter="pint"
                    value={record.codigoTransmissao}
                    onChange={(e) => props.onChangeField('codigoTransmissao', e)}
                    name="codigoTransmissao"
                    label={getMessage(messages, 'configuracaoboleto.label.codigotransmissao')}
                  />
                </div>
              )}

              {isTipoBoletoAilos(record.tipoBoleto) && (
                <>
                  <div className="p-col-12">
                    <LtsInputNumber
                      name={'numeroParcelas'}
                      value={record.numeroParcelas}
                      onChange={(e) => props.onChangeField('numeroParcelas', e)}
                      min={1}
                      max={120}
                      label={getMessage(messages, 'configuracaoboleto.label.numeroparcelas')}
                      format={false}
                    />
                  </div>

                  <div className="p-col-12">
                    <LtsDropdownIdValue
                      value={record.tipoPagamentoDivergente}
                      options={enums.TiposPagamentoDivergente}
                      onChange={(e) => props.onChangeField('tipoPagamentoDivergente', e)}
                      optionLabel="value"
                      optionValue={(v) => v}
                      dataKey="value"
                      name="tipoPagamentoDivergente"
                      label={utils.getMessage(messages, 'configuracaoboleto.label.tipopagamentodivergente')}
                    />
                  </div>
                  {getValorMinimoPagamentoDivergente()}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function getValorMinimoPagamentoDivergente() {
    if (record.tipoPagamentoDivergente && record.tipoPagamentoDivergente.id === 1) {
      return (
        <div className="p-col-12">
          <LtsCurrency
            value={record.valorMinimoPagamentoDivergente}
            maxLength={10}
            onChange={(e) => props.onChangeField('valorMinimoPagamentoDivergente', e)}
            name="valorMinimoPagamentoDivergente"
            label={getMessage(messages, 'configuracaoboleto.label.pagamentodivergente')}
          />
        </div>
      )
    }
  }

  function getDadosReciboRegistro() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.reciboeregistro')}</h3>
            <div className="p-grid form-group">
              {isTipoBoletoAilos(record.tipoBoleto) && (
                <>
                  <div className="p-col-12">
                    <Checkbox
                      inputId="reciboBeneficiario"
                      checked={record.reciboBeneficiario}
                      onChange={(e) => props.onChangeField('reciboBeneficiario', e.checked)}
                      name="reciboBeneficiario"
                    />
                    <label htmlFor="reciboBeneficiario" className="p-checkbox-label p-ml-2">
                      {utils.getMessage(messages, 'configuracaoboleto.label.recibobeneficiario')}
                    </label>
                  </div>

                  <div className="p-col-12">
                    <LtsDropdownIdValue
                      value={record.indicadorRegistroCip}
                      options={enums.RegistrarBoletoCIP}
                      onChange={(e) => props.onChangeField('indicadorRegistroCip', e)}
                      optionLabel="value"
                      optionValue={(v) => v}
                      dataKey="value"
                      name="indicadorRegistroCip"
                      label={utils.getMessage(messages, 'configuracaoboleto.label.indicadorregistrocip')}
                    />
                  </div>
                </>
              )}
              {isTipoBoletoCnab(record.tipoBoleto) && (
                <div className="p-col-12">
                  <LtsDropdownEnum
                    value={record.identificacaoBoletoAceito}
                    options={enums.IdentificacaoTituloAceito}
                    onChange={(value) => props.onChangeField('identificacaoBoletoAceito', value)}
                    optionLabel="label"
                    optionValue="value"
                    name="identificacaoBoletoAceito"
                    label={getMessage(messages, 'configuracaoboleto.label.identificacaoboletoaceito')}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function getDadosEnvioSMS() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.avisossms')}</h3>
            <div className="p-grid form-group">
              <div className="p-col-12">
                <LtsInputNumber
                  name={'enviarAvisoVencimentoSms'}
                  value={record.enviarAvisoVencimentoSms}
                  onChange={(e) => props.onChangeField('enviarAvisoVencimentoSms', e)}
                  label={getMessage(messages, 'configuracaoboleto.label.diasavisosms')}
                  format={false}
                />
              </div>

              <div className="p-col-12">
                <Checkbox
                  inputId="enviarAvisoVencimentoSmsAntesVencimento"
                  checked={record.enviarAvisoVencimentoSmsAntesVencimento}
                  onChange={(e) => props.onChangeField('enviarAvisoVencimentoSmsAntesVencimento', e.checked)}
                  name="enviarAvisoVencimentoSmsAntesVencimento"
                />
                <label htmlFor="enviarAvisoVencimentoSmsAntesVencimento" className="p-checkbox-label p-ml-2">
                  {utils.getMessage(messages, 'configuracaoboleto.label.avisoantesvencimento')}
                </label>
              </div>

              <div className="p-col-12">
                <Checkbox
                  inputId="enviarAvisoVencimentoSmsDiaVencimento"
                  checked={record.enviarAvisoVencimentoSmsDiaVencimento}
                  onChange={(e) => props.onChangeField('enviarAvisoVencimentoSmsDiaVencimento', e.checked)}
                  name="enviarAvisoVencimentoSmsDiaVencimento"
                />
                <label htmlFor="enviarAvisoVencimentoSmsDiaVencimento" className="p-checkbox-label p-ml-2">
                  {utils.getMessage(messages, 'configuracaoboleto.label.avisodiavencimento')}
                </label>
              </div>

              <div className="p-col-12">
                <Checkbox
                  inputId="enviarAvisoVencimentoSmsAposVencimento"
                  checked={record.enviarAvisoVencimentoSmsAposVencimento}
                  onChange={(e) => props.onChangeField('enviarAvisoVencimentoSmsAposVencimento', e.checked)}
                  name="enviarAvisoVencimentoSmsAposVencimento"
                />
                <label htmlFor="enviarAvisoVencimentoSmsAposVencimento" className="p-checkbox-label p-ml-2">
                  {utils.getMessage(messages, 'configuracaoboleto.label.avisodepoisvencimento')}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  function getDadosDescontos() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.descontos')}</h3>
            <div className="p-grid form-group">
              {mostrarTipoDesconto() && (
                <>
                  <div className="p-col-12">
                    <LtsDropdownIdValue
                      value={record.tipoDesconto}
                      options={enums.TipoInstrucaoValor}
                      onChange={(e) => props.onChangeField('tipoDesconto', e)}
                      optionLabel="value"
                      optionValue={(v) => v}
                      dataKey="value"
                      name="tipoDesconto"
                      label={utils.getMessage(messages, 'configuracaoboleto.label.tipodesconto')}
                    />
                  </div>

                  {getResolveTipoDesconto()}
                </>
              )}

              {isTipoBoletoBradesco(record.tipoBoleto) && (
                <div className="p-col-12">
                  <LtsInputNumber
                    name={'diasDesconto'}
                    value={record.diasDesconto}
                    onChange={(e) => props.onChangeField('diasDesconto', e)}
                    label={getMessage(messages, 'configuracaoboleto.label.diasdesconto')}
                    format={false}
                  />
                </div>
              )}

              {mostrarConfigDesconto() && <>{renderConfigDesconto()}</>}

              {mostrarValorAbatimento() && (
                <div className="p-col-12">
                  <LtsCurrency
                    value={record.valorAbatimento}
                    onChange={(e) => props.onChangeField('valorAbatimento', e)}
                    name="valorAbatimento"
                    label={getMessage(messages, 'configuracaoboleto.label.valorabatimento')}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function getResolveTipoDesconto() {
    if (record.tipoDesconto && record.tipoDesconto.id === enums.NomesTipoInstrucaoValor.VALOR_EM_REAIS) {
      return (
        <div className="p-col-12">
          <LtsCurrency
            value={record.valorDesconto}
            onChange={(e) => props.onChangeField('valorDesconto', e)}
            name="valorDesconto"
            label={getMessage(messages, 'configuracaoboleto.label.valordesconto')}
          />
        </div>
      )
    } else if (record.tipoDesconto && record.tipoDesconto.id === enums.NomesTipoInstrucaoValor.PERCENTUAL) {
      return (
        <div className="p-col-12">
          <LtsCurrency
            value={record.percentualDesconto}
            onChange={(e) => props.onChangeField('percentualDesconto', e)}
            name="percentualDesconto"
            mode={'decimal'}
            maxFractionDigits={2}
            label={getMessage(messages, 'configuracaoboleto.label.valorpercentual')}
          />
        </div>
      )
    }
  }

  function getDadosMulta() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.multa')}</h3>
            <div className="p-grid form-group">
              <div className="p-col-12">
                <LtsDropdownIdValue
                  value={record.tipoMulta}
                  options={enums.TipoInstrucaoValor}
                  onChange={(e) => {
                    props.onChangeField('tipoMulta', e)
                    if (autoInstrucoes) {
                      const instrucaoPadrao = buildInstrucoes(record, { tipoMulta: e })
                      props.onChangeField('instrucoes', mergeInstrucoes(record.instrucoes, instrucaoPadrao))
                    }
                  }}
                  optionLabel="value"
                  optionValue={(v) => v}
                  dataKey="value"
                  name="tipoMulta"
                  label={utils.getMessage(messages, 'configuracaoboleto.label.tipomulta')}
                />
              </div>

              {getResolveTipoMulta()}

              {isTipoBoletoBradesco(record.tipoBoleto) && (
                <div className="p-col-12">
                  <LtsInputNumber
                    name={'diasMulta'}
                    value={record.diasMulta}
                    onChange={(e) => props.onChangeField('diasMulta', e)}
                    label={getMessage(messages, 'configuracaoboleto.label.diasmulta')}
                    format={false}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function getResolveTipoMulta() {
    // { id: 1, value: "Valor em Reais" }
    if (record.tipoMulta && record.tipoMulta.id === 1) {
      return (
        <div className="p-col-12">
          <LtsCurrency
            value={record.valorMulta}
            onChange={(e) => {
              props.onChangeField('valorMulta', e)
              if (autoInstrucoes) {
                const instrucaoPadrao = buildInstrucoes(record, { valorMulta: e })
                props.onChangeField('instrucoes', mergeInstrucoes(record.instrucoes, instrucaoPadrao))
              }
            }}
            name="valorMulta"
            label={getMessage(messages, 'configuracaoboleto.label.valormulta')}
          />
        </div>
      )
      // { id: 2, value: "Percentual" }
    } else if (record.tipoMulta && record.tipoMulta.id === 2) {
      return (
        <div className="p-col-12">
          <LtsCurrency
            value={record.percentualMulta}
            onChange={(e) => {
              props.onChangeField('percentualMulta', e)
              if (autoInstrucoes) {
                const instrucaoPadrao = buildInstrucoes(record, { percentualMulta: e })
                props.onChangeField('instrucoes', mergeInstrucoes(record.instrucoes, instrucaoPadrao))
              }
            }}
            name="percentualMulta"
            mode={'decimal'}
            maxFractionDigits={2}
            label={getMessage(messages, 'configuracaoboleto.label.percentualmulta')}
          />
        </div>
      )
    }
  }

  function getDadosJurosMora() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.jurosmora')}</h3>
            <div className="p-grid form-group">
              <div className="p-col-12">
                <LtsDropdownIdValue
                  value={record.tipoJurosMora}
                  options={enums.TipoInstrucaoValor}
                  onChange={(e) => {
                    props.onChangeField('tipoJurosMora', e)
                    if (autoInstrucoes) {
                      const instrucaoPadrao = buildInstrucoes(record, { tipoJurosMora: e })
                      props.onChangeField('instrucoes', mergeInstrucoes(record.instrucoes, instrucaoPadrao))
                    }
                  }}
                  optionLabel="value"
                  optionValue={(v) => v}
                  dataKey="value"
                  name="tipoJurosMora"
                  label={utils.getMessage(messages, 'configuracaoboleto.label.tipojurosmora')}
                />
              </div>

              {getResolveTipoJurosMora()}

              {isTipoBoletoBradesco(record.tipoBoleto) && (
                <div className="p-col-12">
                  <LtsInputNumber
                    name={'diasJuros'}
                    value={record.diasJuros}
                    onChange={(e) => props.onChangeField('diasJuros', e)}
                    label={getMessage(messages, 'configuracaoboleto.label.diasjuros')}
                    format={false}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function getResolveTipoJurosMora() {
    // { id: 1, value: "Valor em Reais" }
    if (record.tipoJurosMora && record.tipoJurosMora.id === 1) {
      return (
        <div className="p-col-12">
          <LtsCurrency
            value={record.valorJurosMora}
            onChange={(e) => {
              props.onChangeField('valorJurosMora', e)
              if (autoInstrucoes) {
                const instrucaoPadrao = buildInstrucoes(record, { valorJurosMora: e })
                props.onChangeField('instrucoes', mergeInstrucoes(record.instrucoes, instrucaoPadrao))
              }
            }}
            name="valorJurosMora"
            label={getMessage(messages, 'configuracaoboleto.label.valorjurosmora')}
          />
        </div>
      )
      // { id: 2, value: "Percentual" }
    } else if (record.tipoJurosMora && record.tipoJurosMora.id === 2) {
      return (
        <div className="p-col-12">
          <LtsCurrency
            value={record.percentualJurosMora}
            onChange={(e) => {
              props.onChangeField('percentualJurosMora', e)
              if (autoInstrucoes) {
                const instrucaoPadrao = buildInstrucoes(record, { percentualJurosMora: e })
                props.onChangeField('instrucoes', mergeInstrucoes(record.instrucoes, instrucaoPadrao))
              }
            }}
            name="percentualJurosMora"
            mode={'decimal'}
            maxFractionDigits={2}
            label={getMessage(messages, 'configuracaoboleto.label.percentualjurosmora')}
          />
        </div>
      )
    }
  }

  function getDadosNegativacaoBaixa() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.negativacaoebaixa')}</h3>
            <div className="p-grid form-group">
              {isTipoBoletoAilos(record.tipoBoleto) && (
                <div className="p-col-12">
                  <LtsInputNumber
                    name={'diasNegativacaoSerasa'}
                    value={record.diasNegativacaoSerasa}
                    onChange={(e) => props.onChangeField('diasNegativacaoSerasa', e)}
                    min={0}
                    max={99}
                    label={getMessage(messages, 'configuracaoboleto.label.negativacaoserasa')}
                    format={false}
                  />
                </div>
              )}

              {isTipoBoletoCnab(record.tipoBoleto) && (
                <div className="p-col-12">
                  <LtsInputNumber
                    name={'diasBaixa'}
                    value={record.diasBaixa}
                    onChange={(e) => props.onChangeField('diasBaixa', e)}
                    label={getMessage(messages, 'configuracaoboleto.label.diasbaixa')}
                    format={false}
                  />
                </div>
              )}

              {(isTipoBoletoSicoob(record.tipoBoleto) ||
                isTipoBoletoItau(record.tipoBoleto) ||
                isTipoBoletoBB(record.tipoBoleto)) && (
                <div className="p-col-12">
                  <LtsInputNumber
                    name={'diasLimitePagamento'}
                    value={record.diasLimitePagamento}
                    onChange={(e) => props.onChangeField('diasLimitePagamento', e)}
                    label={getMessage(messages, 'configuracaoboleto.label.diaslimitepagamento')}
                    format={false}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function getDadosInstrucoesCobranca() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.instrucoesescobranca')}</h3>
            <div className="p-grid form-group">
              {isTipoBoletoCnab(record.tipoBoleto) && !isTipoBancoItau(record.codigoBanco) && (
                <div className="p-col-12">
                  <LtsDropdownIdValue
                    value={record.tipoCobranca}
                    options={getCodigoCarteiraOptions()}
                    onChange={(e) => {
                      props.onChangeField('tipoCobranca', e)
                    }}
                    optionLabel="value"
                    optionValue={(v) => v}
                    dataKey="value"
                    name="tipoCobranca"
                    label={utils.getMessage(messages, 'configuracaoboleto.label.tipocobranca')}
                  />
                </div>
              )}

              <div className="p-col-12">
                <Checkbox
                  inputId="autoInstrucoes"
                  checked={autoInstrucoes}
                  onChange={(e) => {
                    setAutoInstrucoes(e.checked)

                    if (e.checked) {
                      const instrucaoPadrao = buildInstrucoes(record)
                      if (instrucaoPadrao) {
                        props.onChangeField('instrucoes', mergeInstrucoes(record.instrucoes, instrucaoPadrao))
                      }
                    }
                  }}
                  name="autoInstrucoes"
                />
                <label htmlFor="autoInstrucoes" className="p-checkbox-label p-ml-2">
                  {getMessage(messages, 'configuracaoboleto.label.autoinstrucoes')}
                </label>
              </div>

              <div className="p-col-12">
                <LtsTextArea
                  value={record.instrucoes}
                  onChange={(e) => props.onChangeField('instrucoes', e)}
                  name="instrucoes"
                  rows={3}
                  label={getMessage(messages, 'configuracaoboleto.label.instrucoes')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  function getCabecalho() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>
              {utils.getMessage(messages, 'configuracaoboleto.label.configuracaoboleto')} {record.oid || ''}
            </h3>

            <div className="p-grid form-group">
              <div className="p-col-12">
                <LtsLookupUnidade
                  disabled={props.disableUnit}
                  label={utils.getMessage(messages, 'configuracaoboleto.label.unidade')}
                  value={_.get(record, 'unidade.value', '')}
                  oidRecord={_.get(record, 'unidade.id', '')}
                  history={props.history}
                  onChange={(e) => props.onChangeField('unidade', e)}
                />
              </div>

              <div className="p-col-12">
                <LtsInputText
                  value={record.nome}
                  onChange={(e) => props.onChangeField('nome', e)}
                  name="nome"
                  autoFocus={true}
                  maxLength={100}
                  label={getMessage(messages, 'configuracaoboleto.label.nome')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  function handleValidarToken() {
    props
      .validarToken(record.oid)
      .then((response) => {
        const data = response.data
        setValidacaoToken({
          requestInfo: data.requestInfo || '',
          responseInfo: data.responseInfo || '',
        })
      })
      .catch((error) => {
        const errorData = error.response?.data || {}
        setValidacaoToken({
          requestInfo: '',
          responseInfo: errorData.mensagem || 'Erro ao validar token',
        })
      })
  }

  function getValidacaoToken() {
    const calculateRowsByContent = (content, minRows = 5, maxRows = 30, lineLength = 120) => {
      if (!content) return minRows

      const estimatedRows = content.split('\n').reduce((acc, line) => {
        const currentLineLength = line?.length ?? 0
        const wrappedLines = Math.max(1, Math.ceil(currentLineLength / lineLength))
        return acc + wrappedLines
      }, 0)

      return Math.max(minRows, Math.min(maxRows, estimatedRows))
    }

    const requestRows = calculateRowsByContent(validacaoToken.requestInfo)
    const responseRows = calculateRowsByContent(validacaoToken.responseInfo)

    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <h3>{utils.getMessage(messages, 'configuracaoboleto.label.validacaotoken')}</h3>
            <div className="p-grid form-group">
              <div className="p-col-12">
                <Tooltip
                  target=".btn-checar-credenciais"
                  content={!record?.oid ? 'Salve a configuração primeiro para checar as credenciais' : ''}
                />
                <span className="btn-checar-credenciais">
                  <Button
                    label={
                      props.loadingValidarToken
                        ? utils.getMessage(messages, 'configuracaoboleto.label.validandoToken')
                        : utils.getMessage(messages, 'configuracaoboleto.label.validarToken')
                    }
                    icon="pi pi-cloud-upload"
                    className="p-button-warning"
                    style={{ width: 'auto' }}
                    onClick={handleValidarToken}
                    loading={props.loadingValidarToken}
                    disabled={props.loadingValidarToken || !record.oid}
                  />
                </span>
              </div>
              <div className="p-col-12">
                <LtsTextArea
                  value={validacaoToken.requestInfo}
                  name="validacaoTokenRequest"
                  rows={requestRows}
                  label={utils.getMessage(messages, 'configuracaoboleto.label.validacaoTokenRequest')}
                  readOnly={true}
                />
              </div>
              <div className="p-col-12">
                <LtsTextArea
                  value={validacaoToken.responseInfo}
                  name="validacaoTokenResponse"
                  rows={responseRows}
                  label={utils.getMessage(messages, 'configuracaoboleto.label.validacaoTokenResponse')}
                  readOnly={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="configuracao-boleto-form">
      <div className="p-grid equal-height-row">
        <div className="p-col-12 p-md-6 p-lg-6 p-xl-6">{getCabecalho()}</div>
        <div className="p-col-12 p-md-6 p-lg-6 p-xl-6">{getDadosTipoBoletoRetorno()}</div>
      </div>

      <div className="p-grid">
        <div className="p-col-12">{getDadosBancarios()}</div>
      </div>

      <div className="p-grid equal-height-row">
        <div className="p-col-12 p-md-6 p-lg-6 p-xl-6">{getDadosDocumentoEmissao()}</div>
        <div className="p-col-12 p-md-6 p-lg-6 p-xl-6">{getDadosConvenioCarteira()}</div>
        {mostrarDadosDesconto() && <div className="p-col-12 p-md-6 p-lg-6 p-xl-6">{getDadosDescontos()}</div>}
        <div className="p-col-12 p-md-6 p-lg-6 p-xl-6">{getDadosMulta()}</div>
        <div className="p-col-12 p-md-6 p-lg-6 p-xl-6">{getDadosJurosMora()}</div>
        <div className="p-col-12 p-md-6 p-lg-6 p-xl-6">{getDadosProtesto()}</div>

        {mostrarDadosNegativacaoBaixa() && (
          <div className="p-col-12 p-md-6 p-lg-6 p-xl-6">{getDadosNegativacaoBaixa()}</div>
        )}

        {isTipoBoletoAilos(record.tipoBoleto) && (
          <div className="p-col-12 p-md-6 p-lg-6 p-xl-6">{getDadosEnvioSMS()}</div>
        )}

        {mostrarDadosReciboRegistro() && (
          <div className="p-col-12 p-md-6 p-lg-6 p-xl-6">{getDadosReciboRegistro()}</div>
        )}
        <div className="p-col-12 p-md-6 p-lg-6 p-xl-6">{getDadosInstrucoesCobranca()}</div>
        {!isTipoBoletoCnab(record.tipoBoleto) && <div className="p-col-12 p-md-6 p-lg-6 p-xl-6">{getDadosPix()}</div>}

        {mostrarDadosAutenticacaoApi() && (
          <div className="p-col-12 p-md-6 p-lg-6 p-xl-6">{getDadosAutenticacaoApi()}</div>
        )}

        {exibeValidarToken && <div className="p-col-12 p-md-6 p-lg-6 p-xl-6">{getValidacaoToken()}</div>}
      </div>

      {(isTipoBoletoCnab(record.tipoBoleto) || isTipoRetornoBoletoValido()) && (
        <div className="p-grid">
          <div className="p-col-12">{getDadosArquivoRetorno()}</div>
        </div>
      )}
    </div>
  )
}
